var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1882_20036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66774 25.7898C2.85683 25.7898 2.18902 25.524 1.63251 25.0071C1.076 24.4903 0.789795 23.8553 0.789795 23.1169V3.35754C0.789795 2.60438 1.076 1.98414 1.63251 1.46726C2.18902 0.950391 2.87273 0.68457 3.66774 0.68457H28.1224C28.9333 0.68457 29.6011 0.950391 30.1576 1.46726C30.7141 1.98414 31.0003 2.61915 31.0003 3.35754V23.1169C31.0003 23.87 30.7141 24.4903 30.1576 25.0071C29.6011 25.524 28.9174 25.7898 28.1224 25.7898H3.66774ZM3.66774 23.5747H28.1224C28.2496 23.5747 28.3609 23.5304 28.4563 23.427C28.5517 23.3384 28.6153 23.235 28.6153 23.1169V3.35754C28.6153 3.2394 28.5676 3.13603 28.4563 3.04742C28.3609 2.95881 28.2496 2.89974 28.1224 2.89974H3.66774C3.54054 2.89974 3.42924 2.94404 3.33384 3.04742C3.23844 3.13603 3.17484 3.2394 3.17484 3.35754V23.1169C3.17484 23.235 3.22254 23.3384 3.33384 23.427C3.42924 23.5156 3.54054 23.5747 3.66774 23.5747ZM5.16237 20.2519H12.3175V18.0367H5.16237V20.2519ZM19.9496 17.1359L27.2478 10.3575L25.5465 8.77733L19.9337 14.0199L17.66 11.9081L16.0064 13.4883L19.9337 17.1359H19.9496ZM5.16237 14.3448H12.3175V12.1296H5.16237V14.3448ZM5.16237 8.43767H12.3175V6.2225H5.16237V8.43767Z",
    fill: "#01A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1882_20036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2105,
    height: 25.1053,
    fill: "white",
    transform: "translate(0.789795 0.68457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.4a3735231bcc28e69003ed31d1110008.svg";
export { ForwardRef as ReactComponent };